/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { ScvAttribute } from './ScvAttribute.defs';

/**
 * Customer ID.
 * @export
 */
export const SCV_ATTRIBUTE_CUSTOMER_ID: ScvAttribute = {
  key: `$customerid`,
  title: `Customer ID`,
  type: `string`,
};

/**
 * Date created.
 * @export
 */
export const SCV_ATTRIBUTE_DATE_CREATED: ScvAttribute = {
  key: `$createdDatetime`,
  title: `Date created`,
  type: `date`,
};

/**
 * External system ID.
 * @export
 */
export const SCV_ATTRIBUTE_EXTERNAL_SYSTEM_ID: ScvAttribute = {
  key: `$tertiaryid`,
  title: `External system ID`,
  type: `string`,
};

/**
 * Last updated.
 * @export
 */
export const SCV_ATTRIBUTE_LAST_UPDATED: ScvAttribute = {
  key: `$updatedDatetime`,
  title: `Last updated`,
  type: `date`,
};

/**
 * Primary email.
 * @export
 */
export const SCV_ATTRIBUTE_PRIMARY_EMAIL: ScvAttribute = {
  key: `$verifiedEmail`,
  title: `Primary email`,
  type: `string`,
};

/**
 * Segments.
 * @export
 */
export const SCV_ATTRIBUTE_SEGMENTS: ScvAttribute = {
  key: `$segments`,
  title: `Segments`,
  type: `object`,
};

/**
 * Username.
 * @export
 */
export const SCV_ATTRIBUTE_USERNAME: ScvAttribute = {
  key: `$username`,
  title: `Username`,
  type: `string`,
};

/**
 * All SCV system attributes.
 * @export
 */
export const SCV_SYSTEM_ATTRIBUTES: Array<ScvAttribute> = [
  SCV_ATTRIBUTE_CUSTOMER_ID,
  SCV_ATTRIBUTE_DATE_CREATED,
  SCV_ATTRIBUTE_EXTERNAL_SYSTEM_ID,
  SCV_ATTRIBUTE_LAST_UPDATED,
  SCV_ATTRIBUTE_PRIMARY_EMAIL,
  SCV_ATTRIBUTE_SEGMENTS,
  SCV_ATTRIBUTE_USERNAME,
];
